import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import OptionSelect, { IOption } from './OptionSelect';
import TruckIcon from '../../icons/IconLib/TruckIcon';

/** Order `Type` filter: 0 — all orders, otherwise orders with the same `Type` (2 — הקפצה). */
export const ORDER_AKPACA_TYPE = {
    ALL: 0,
    REGULAR: 1,
    AKPACA_ONLY: 2,
} as const;

export type OrderAkpacaTypeValue = typeof ORDER_AKPACA_TYPE[keyof typeof ORDER_AKPACA_TYPE];

interface Props {
    value: OrderAkpacaTypeValue;
    onSelect: (value: OrderAkpacaTypeValue) => void;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    leadingIcon?: React.ReactNode | null;
    className?: string;
}

const OrderAkpacaTypeSelector: React.FC<Props> = ({
    value,
    onSelect,
    placeholder,
    disabled,
    readOnly,
    leadingIcon,
    className,
}) => {
    const [t] = useTranslation('selectors');

    const options = useMemo<IOption[]>(
        () => [
            { value: ORDER_AKPACA_TYPE.ALL, label: t('selectors_orderAkpacaType_all') },
            { value: ORDER_AKPACA_TYPE.AKPACA_ONLY, label: t('selectors_orderAkpacaType_akpacaOnly') },
            { value: ORDER_AKPACA_TYPE.REGULAR, label: t('selectors_orderAkpacaType_regular') },
        ],
        [t],
    );

    return (
        <OptionSelect
            options={options}
            value={options.find((o) => o.value === value) ?? null}
            onSelect={(o) => onSelect((o?.value ?? ORDER_AKPACA_TYPE.ALL) as OrderAkpacaTypeValue)}
            placeholder={placeholder ?? t('selectors_orderAkpacaType_placeholder')}
            disabled={disabled}
            readOnly={readOnly}
            // Same icon as the הקפצה toggle in the order form.
            leadingIcon={leadingIcon === undefined ? <TruckIcon /> : leadingIcon}
            className={className}
        />
    );
};

export default OrderAkpacaTypeSelector;
